<template>
  <div :class="rootClass">
    <v-main
      class="auth-pages"
      :class="showClientLayout ? 'd-flex flex-grow-1 align-center' : ''"
    >
      <div
        class="header-auth position-relative border-radius-xl min-vh-100"
        :class="
          showClientLayout
            ? 'bg-client-light d-flex flex-column justify-center'
            : ''
        "
      >
        <v-container class="py-0">
          <v-row :class="showClientLayout ? 'justify-center align-center' : ''">
            <v-col
              lg="4"
              md="7"
              :class="
                showClientLayout
                  ? 'd-flex flex-column mx-auto text-center'
                  : 'd-flex flex-column mx-lg-0 mx-auto'
              "
            >
              <Transition>
                <div>
                  <v-img
                    v-if="showClientLayout"
                    eager
                    :src="whiteLabelBrand.authLogo"
                    :alt="whiteLabelBrand.logoAlt"
                    :max-width="logoWidth"
                    class="mb-6 mx-auto"
                    contain
                  />
                  <v-card class="mt-sm-8 mt-md-5 mt-7 bg-transparent">
                    <div class="card-padding pb-0">
                      <h4 class="text-h4 font-weight-bolder text-typo mb-2">
                        {{ $t("publicPages.passwordRecovery.title") }}
                      </h4>
                      <p class="mb-0 text-body">
                        {{ helperMessage }}
                      </p>
                    </div>

                    <form @submit.prevent="submit">
                      <div v-for="(error, idx) in errors" :key="idx">
                        <base-material-alert color="error" dark dismissible>
                          <span v-if="error.fieldName || error.fieldNameKey">
                            {{ getErrorFieldName(error) }} —
                          </span>
                          {{ getErrorMessage(error) }}
                        </base-material-alert>
                      </div>

                      <div class="card-padding pb-4">
                        <base-material-alert
                          v-if="sucesso"
                          color="success"
                          dark
                          dismissible
                          class="mb-4"
                        >
                          {{ mensagemSucesso }}
                        </base-material-alert>

                        <template v-else-if="isResetMode">
                          <label
                            class="text-xs text-typo font-weight-bolder ms-1"
                          >
                            {{ $t("publicPages.passwordRecovery.newPassword") }}
                          </label>
                          <v-text-field
                            :disabled="loading"
                            hide-details
                            outlined
                            background-color="rgba(255,255,255,.9)"
                            color="rgba(0,0,0,.6)"
                            light
                            height="40"
                            v-model="redefinicao.senha"
                            :placeholder="
                              $t('publicPages.passwordRecovery.newPassword')
                            "
                            type="password"
                            class="
                              input-style
                              font-size-input
                              border border-radius-md
                              placeholder-lighter
                              text-color-light
                              mb-4
                              mt-2
                            "
                          />

                          <label
                            class="text-xs text-typo font-weight-bolder ms-1"
                          >
                            {{
                              $t(
                                "publicPages.passwordRecovery.confirmNewPassword"
                              )
                            }}
                          </label>
                          <v-text-field
                            :disabled="loading"
                            hide-details
                            outlined
                            background-color="rgba(255,255,255,.9)"
                            color="rgba(0,0,0,.6)"
                            light
                            height="40"
                            v-model="redefinicao.confirmacaoSenha"
                            :placeholder="
                              $t(
                                'publicPages.passwordRecovery.confirmNewPassword'
                              )
                            "
                            type="password"
                            class="
                              input-style
                              font-size-input
                              border border-radius-md
                              placeholder-lighter
                              text-color-light
                              mb-4
                              mt-2
                            "
                          />
                        </template>

                        <template v-else>
                          <label
                            class="text-xs text-typo font-weight-bolder ms-1"
                          >
                            {{ $t("publicPages.passwordRecovery.cpf") }}
                          </label>
                          <v-text-field
                            :disabled="loading"
                            hide-details
                            outlined
                            background-color="rgba(255,255,255,.9)"
                            color="rgba(0,0,0,.6)"
                            light
                            height="40"
                            v-model="cliente.email"
                            :placeholder="
                              $t('publicPages.passwordRecovery.cpfPlaceholder')
                            "
                            class="
                              input-style
                              font-size-input
                              border border-radius-md
                              placeholder-lighter
                              text-color-light
                              mb-4
                              mt-2
                            "
                          />
                        </template>

                        <v-btn
                          v-if="!sucesso"
                          elevation="0"
                          :ripple="false"
                          height="39"
                          type="submit"
                          :class="submitButtonClass"
                          :color="submitButtonColor"
                          small
                          :disabled="loading"
                          :loading="loading"
                        >
                          {{ submitLabel }}
                        </v-btn>

                        <div class="text-center mt-2">
                          <router-link
                            class="text-body text-decoration-underline"
                            :to="loginRoute"
                          >
                            {{ $t("publicPages.passwordRecovery.backToLogin") }}
                          </router-link>
                        </div>
                      </div>
                    </form>

                    <div class="text-center">
                      <div class="text-sm text-body mb-4">
                        <select
                          v-model="selectedLocale"
                          :aria-label="
                            $t('publicPages.common.languageSelector')
                          "
                          :disabled="loading"
                        >
                          <option
                            v-for="(lang, i) in langs"
                            :key="`Lang${i}`"
                            :value="lang.item"
                          >
                            {{ lang.description }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </v-card>
                </div>
              </Transition>
            </v-col>

            <v-col
              v-if="!showClientLayout"
              cols="6"
              class="
                d-lg-flex d-none
                h-100
                my-auto
                pe-0
                pt-0
                position-absolute
                top-0
                end-0
                text-center
                justify-center
                flex-column
              "
            >
              <div
                class="
                  position-relative
                  bg-gradient-primary
                  h-100
                  ma-4
                  px-16
                  border-radius-lg
                  d-flex
                  flex-column
                  justify-center
                "
              >
                <v-img
                  src="@/assets/img/shapes/pattern-lines.svg"
                  alt=""
                  class="position-absolute opacity-4 start-0 h-100 w-100"
                />
                <div class="position-relative">
                  <v-img
                    src="@/assets/Cajupe_simples.png"
                    :alt="$t('publicPages.passwordRecovery.defaultLogoAlt')"
                    max-width="250"
                    class="w-100 position-relative z-index-2 mx-auto"
                  />
                </div>
                <h4 class="text-h4 mt-10 text-white font-weight-bolder mb-2">
                  {{ $t("Sua_jornada_inicia_aqui") }}
                </h4>
                <p class="text-white">
                  {{ $t("Pucos_cliques_mundo_possibilidades") }}
                </p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-main>
    <content-footer
      auth
      :white-label-brand="whiteLabelBrand"
      v-if="showClientLayout"
    />
  </div>
</template>

<script>
import AuthDataService from "@/services/AuthDataService";
import ContentFooter from "@/components/Footer.vue";
import { LANGUAGE_OPTIONS, saveLocale } from "@/utils/locale";
import {
  getLoginRouteByBrand,
  isClientWhiteLabel,
  resolveAppWhiteLabelBrand,
} from "@/utils/whiteLabel";

export default {
  name: "EsqueceuSenha",
  components: {
    ContentFooter,
  },
  data() {
    return {
      errors: [],
      langs: LANGUAGE_OPTIONS,
      cliente: {
        email: "",
      },
      redefinicao: {
        senha: "",
        confirmacaoSenha: "",
      },
      sucesso: false,
      mensagemSucessoKey: "",
      token: "",
      isResetMode: false,
      loading: false,
    };
  },
  mounted() {
    this.syncModeFromRoute();
  },
  watch: {
    "$route.query.token"() {
      this.syncModeFromRoute();
    },
  },
  computed: {
    whiteLabelBrand() {
      return resolveAppWhiteLabelBrand();
    },
    showClientLayout() {
      return isClientWhiteLabel(this.whiteLabelBrand);
    },
    rootClass() {
      return this.showClientLayout
        ? "bg-client-light d-flex flex-column min-vh-100"
        : "";
    },
    logoWidth() {
      return this.whiteLabelBrand.authLogoWidth || 260;
    },
    helperMessage() {
      if (this.isResetMode) {
        return this.$t("publicPages.passwordRecovery.resetInstruction");
      }
      return this.$t("publicPages.passwordRecovery.requestInstruction");
    },
    submitLabel() {
      return this.$t(
        this.isResetMode
          ? "publicPages.passwordRecovery.saveNewPassword"
          : "publicPages.passwordRecovery.sendInstructions"
      );
    },
    mensagemSucesso() {
      return this.mensagemSucessoKey ? this.$t(this.mensagemSucessoKey) : "";
    },
    submitButtonClass() {
      return `
        font-weight-bold
        text-uppercase
        py-2
        px-6
        me-2
        mt-7
        mb-2
        w-100
        ${
          this.showClientLayout
            ? "white--text btn-client"
            : "btn-primary bg-gradient-primary"
        }
      `;
    },
    submitButtonColor() {
      return this.showClientLayout
        ? this.whiteLabelBrand.authButtonColor || "#253077"
        : "#5e72e4";
    },
    loginRoute() {
      return getLoginRouteByBrand(this.whiteLabelBrand);
    },
    selectedLocale: {
      get() {
        return this.$i18n.locale;
      },
      set(locale) {
        this.$i18n.locale = saveLocale(locale);
      },
    },
  },
  methods: {
    submit() {
      if (this.sucesso || this.loading) {
        return;
      }

      if (this.isResetMode) {
        this.redefinirSenha();
        return;
      }

      this.enviar();
    },
    getTokenFromAddressBar() {
      if (typeof window === "undefined") {
        return "";
      }

      const token = new URLSearchParams(window.location.search).get("token");
      return token ? String(token).trim() : "";
    },
    syncModeFromRoute() {
      const routeToken = this.$route?.query?.token;
      const resolvedToken = routeToken || this.getTokenFromAddressBar();
      this.token = resolvedToken ? String(resolvedToken).trim() : "";
      this.isResetMode = !!this.token;
      this.errors = [];
      this.sucesso = false;
      this.mensagemSucessoKey = "";
      this.loading = false;
    },
    limparCpf(cpf) {
      return (cpf || "").replace(/\D/g, "");
    },
    enviar() {
      const cpf = this.limparCpf(this.cliente.email);
      this.errors = [];

      if (!cpf) {
        this.errors.push({
          fieldNameKey: "publicPages.passwordRecovery.cpf",
          messageKey: "Campo_obrigatorio",
        });
        return;
      }

      this.loading = true;
      AuthDataService.forgot({ email: cpf })
        .then(() => {
          this.sucesso = true;
          this.mensagemSucessoKey = "publicPages.passwordRecovery.requestSent";
        })
        .catch((error) => {
          this.pushError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    redefinirSenha() {
      this.errors = [];

      if (!this.redefinicao.senha || !this.redefinicao.confirmacaoSenha) {
        this.errors.push({
          fieldNameKey: "publicPages.passwordRecovery.newPassword",
          messageKey: "Campo_obrigatorio",
        });
        return;
      }

      if (this.redefinicao.senha !== this.redefinicao.confirmacaoSenha) {
        this.errors.push({
          fieldNameKey: "publicPages.passwordRecovery.newPassword",
          messageKey: "senhas_nao_conferem",
        });
        return;
      }

      this.loading = true;
      AuthDataService.recoveryPassword({
        token: this.token,
        senha: this.redefinicao.senha,
        confirmacaoSenha: this.redefinicao.confirmacaoSenha,
      })
        .then(() => {
          this.sucesso = true;
          this.mensagemSucessoKey =
            "publicPages.passwordRecovery.passwordChanged";
        })
        .catch((error) => {
          this.pushError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    pushError(error) {
      const response = error?.response?.data || {};
      const status = error?.response?.status;
      const rawMessage = response.message || "";
      const isUserNotFoundOnForgot =
        !this.isResetMode &&
        status === 404 &&
        rawMessage.toLowerCase().includes("usuário não encontrado");

      if (isUserNotFoundOnForgot) {
        this.errors.push({
          fieldNameKey: "publicPages.passwordRecovery.errorTitle",
          messageKey: "publicPages.passwordRecovery.cpfNotFound",
        });
        return;
      }

      const serverError = (response.error || "")
        .toString()
        .trim()
        .toLowerCase();
      const hideTechnicalField =
        serverError === "not found" ||
        serverError === "bad request" ||
        serverError === "unauthorized";

      this.errors.push({
        fieldName: hideTechnicalField ? "" : response.error,
        fieldNameKey: hideTechnicalField
          ? "publicPages.passwordRecovery.errorTitle"
          : response.error
          ? ""
          : "Erro",
        message: response.message,
        messageKey: response.message ? "" : "Tente_novamente_mais_tarde",
      });
    },
    getErrorFieldName(error) {
      return error.fieldNameKey
        ? this.$t(error.fieldNameKey)
        : error.fieldName || "";
    },
    getErrorMessage(error) {
      return error.messageKey ? this.$t(error.messageKey) : error.message || "";
    },
  },
};
</script>

<style scoped>
.min-vh-100 {
  min-height: 100vh;
}

.bg-client-light {
  background-color: #f6f6f6 !important;
}

.btn-client {
  background-color: #253077 !important;
  color: #ffffff !important;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.9s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
